import { useSubAccountStore } from "@/store/SubAccountStore";
import { useEffect, useState } from "react";
import { useGlobalStore } from "@/store/GlobalStore";
import { getSearchConfig } from "@/pages/operate-record/config/search-config";

import { ISelectSearchConfig } from "@/components/dynamic-form";
import { FormInstance } from "antd";
import { useWatch } from "antd/es/form/Form";
import { ModuleType } from "@/pages/operate-record/types";

export const searchConfig = getSearchConfig();
const getUniqArray: any = (arr: any[], key: string) => {
  return Object.values(
    arr.reduce((accumulator: any, currentValue: any) => {
      accumulator[currentValue[key]] = currentValue;
      return accumulator;
    }, {})
  );
};
export function useFormConfig() {
  const { allSubAccountList } = useSubAccountStore();
  const { userInfo, isDomestic, isPictureUser } = useGlobalStore();

  useEffect(() => {
    if (!userInfo) return;

    const subUserNameList = allSubAccountList.map((s: any) => ({
      label: s.userName,
      value: s.userId,
    }));

    const config = searchConfig.find(
      (c) => c.field === "userId"
    ) as unknown as ISelectSearchConfig;

    if (config?.props) {
      const self = [{ label: userInfo.userName, value: userInfo?.userId }];
      config.props.options = subUserNameList.length
        ? getUniqArray(self.concat(subUserNameList), "value")
        : self;
    }

    const taskTypeConfig = searchConfig.find(
      (c) => c.field === "taskType"
    ) as unknown as ISelectSearchConfig;
    if (taskTypeConfig?.props && (!isDomestic || isPictureUser)) {
      taskTypeConfig.props.options = taskTypeConfig.props.options?.filter(
        (item) => !item.isPictureHidden
      );
    }

    const operateSourceConfig = searchConfig.find(
      (c) => c.field === "operateSource"
    ) as unknown as ISelectSearchConfig;
    if (operateSourceConfig?.props && !isDomestic) {
      operateSourceConfig.props.options =
        operateSourceConfig.props.options?.filter((item) => !item.isFoxHidden);
    }
  }, [allSubAccountList, userInfo, isDomestic, isPictureUser]);

  return { searchConfig };
}

export function useTaskIdConfig(form: FormInstance) {
  const taskType = useWatch("taskType", form);

  const [showTaskId, setShowTaskId] = useState<boolean>();
  useEffect(() => {
    const showTaskId =
      taskType === ModuleType.AnalysisTask ||
      taskType === ModuleType.RenderingTask;

    setShowTaskId(showTaskId);

    const config = searchConfig.find((c) => c.field === "taskIds");
    if (config) {
      config.hidden = !showTaskId;
    }
  }, [taskType]);

  return { showTaskId };
}
